<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="0"
      :BackPath="'/A01'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      :Type="true"
      :ImgUrl="'A0103.png'"
      :ImgUrls="'A0103.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container4.vue";
export default {
  name: "A0103",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "",
        title: "讓創新觸手可及",
        plainlist: true,
        list: [
          {
            body: "全球每三人中就有一人無法獲得放射治療，而這種差距更不只存在於低收入國家或非洲。正因如此，我們致力提升各地社區的癌症照護品質。透過整合系統、軟體、服務與人工智慧的全面策略，我們協助癌症中心拓展服務範疇，惠及更多患者。"
          },
          {
            body: "讓創新觸手可及，意味著要針對現實情況來設計，提供模組化和可擴充的解決方案，讓醫護團隊能在壓力下穩定運作。"
          },
          {
            body: "可及性需要逐步建構，而且必須能同時兼具實用性、擴充能力和韌性，讓全球各地的患者不再受限於其所處的醫療體系。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
